import { render, staticRenderFns } from "./StudentQuizHistory.vue?vue&type=template&id=7266b272&"
import script from "./StudentQuizHistory.vue?vue&type=script&lang=js&"
export * from "./StudentQuizHistory.vue?vue&type=script&lang=js&"
import style0 from "./StudentQuizHistory.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports